import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePingIdentityInfo } from '../../hooks/usePingIdentityInfo';
import { useAccountMenuControls } from '../../hooks/useAccountMenuControls';
import { getUserInitials } from '../../helpers/getUserInitials';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import UserAccountMenu from './UserAccountMenu';
import styles from './index.module.scss';

export default function UserAccountSection() {
  const { t } = useTranslation();
  const { isLoggedIn, name, surname } = usePingIdentityInfo();
  const {
    isDropdownOpen,
    containerRef,
    handleAccountClick,
    handleCloseMenu,
    handleLoginClick,
    handleLogoutClick,
    handleMyAccountClick,
  } = useAccountMenuControls();

  const userInitials = useMemo(
    () => getUserInitials(name, surname),
    [name, surname],
  );

  if (isLoggedIn) {
    return (
      <div className={styles.accountContainer} ref={containerRef}>
        <button className={styles.accountButton} onClick={handleAccountClick}>
          <span className={styles.welcomeText}>
            {t('informa.ping-identity.ribbon.user-section.welcome', { name })}
          </span>
          <div className={styles.avatar}>
            <span className={styles.initials}>{userInitials}</span>
          </div>
        </button>

        <UserAccountMenu
          isOpen={isDropdownOpen}
          onClose={handleCloseMenu}
          onMyAccountClick={handleMyAccountClick}
          onLogoutClick={handleLogoutClick}
        />
      </div>
    );
  }

  return (
    <button className={styles.loginButton} onClick={handleLoginClick}>
      <AccountCircleOutlinedIcon fontSize="inherit" color="inherit" />
      <span className={styles.loginText}>
        {t('informa.ping-identity.ribbon.user-section.login')}
      </span>
    </button>
  );
}
